import { ElementType, lazy } from "react";
import Draft from "../pages/admin/Communication/Draft";
import Inbox from "../pages/admin/Communication/Inbox";
import Message from "../pages/admin/Communication/Message";
import MessageDetails from "../pages/admin/Communication/MessageDetails";
import Sent from "../pages/admin/Communication/Sent";
import SingleEmail from "../pages/admin/Communication/SingleEmail/SingleEmail";
import Starred from "../pages/admin/Communication/Starred";
import CompanyProfile from "../pages/admin/CompanyProfile/CompanyProfile";
import Dashboard from "../pages/admin/Dashboard/Dashboard";
import AllFeatures from "../pages/admin/ProductManagement/Feature/AllFeatures";
import AllProducts from "../pages/admin/ProductManagement/Product/AllProducts";
import AdminProfile from "../pages/admin/Profile/Profile";
import Reports from "../pages/admin/Report/Reports";
import AllTemplates from "../pages/admin/TicketManagement/Templates/AllTemplates";
import ManageTemplate from "../pages/admin/TicketManagement/Templates/ManageTemplate";
import TemplateDetails from "../pages/admin/TicketManagement/Templates/TemplateDetails";
import AllTickets from "../pages/admin/TicketManagement/Tickets/AllTickets";
import AssignToMe from "../pages/admin/TicketManagement/Tickets/AssignToMe";
import ManageTicket from "../pages/admin/TicketManagement/Tickets/ManageTicket";
import ApproverTicketDetails from "../pages/admin/TicketManagement/Tickets/TicketDetails/ApproverTicketDetails";
import CreatorTicketDetails from "../pages/admin/TicketManagement/Tickets/TicketDetails/CreatorTicketDetails";
import LogTicketDetails from "../pages/admin/TicketManagement/Tickets/TicketDetails/LogTicketDetails";
import User from "../pages/admin/UserManagement/User";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Login from "../pages/auth/Login";
import ResetPassword from "../pages/auth/ResetPassword";
import { Role } from "../types/common";
import KeycloakSignIn from "../pages/auth/KeycloakSignIn";
const NotFound = lazy(() => import("../pages/NotFound"));
const SignUp = lazy(() => import("../pages/auth/SignUp"));

// TODO: Need to add lazy loading in all pages after complete development.

export interface RouteType {
  path: string;
  element: ElementType;
  roles: Role[];
  name?: string;
  children?: {
    path: string;
    element: ElementType;
  }[];
}

// auth routers
export const sidebarRouters: RouteType[] = [
  // Dashboard Routes
  {
    path: "/admin/dashboard",
    element: Dashboard,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/user/dashboard",
    element: Dashboard,
    roles: ["User"],
  },

  // Communication-> Message Routes
  {
    path: "/admin/communication/message",
    element: Message,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/message/:id",
    element: MessageDetails,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/user/communication/message",
    element: Message,
    roles: ["User"],
  },
  {
    path: "/user/communication/message/:id",
    element: MessageDetails,
    roles: ["User"],
  },

  // Communication-> Email Routes (Admin)
  {
    path: "/admin/communication/email/inbox",
    element: Inbox,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/sent",
    element: Sent,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/starred",
    element: Starred,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/draft",
    element: Draft,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/inbox/:id",
    element: SingleEmail,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/starred/:id",
    element: SingleEmail,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/sent/:id",
    element: SingleEmail,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/communication/email/draft/:id",
    element: SingleEmail,
    roles: ["super_admin", "Admin"],
  },

  // Communication-> Email Routes (User)
  {
    path: "/user/communication/email",
    element: Inbox,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/inbox",
    element: Inbox,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/sent",
    element: Sent,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/starred",
    element: Starred,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/draft",
    element: Draft,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/inbox/:id",
    element: SingleEmail,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/starred/:id",
    element: SingleEmail,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/sent/:id",
    element: SingleEmail,
    roles: ["User"],
  },
  {
    path: "/user/communication/email/draft/:id",
    element: SingleEmail,
    roles: ["User"],
  },

  // Ticket Management-> Ticket Routes (Admin)
  {
    path: "/admin/ticket-management/all-tickets",
    element: AllTickets,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/ticket-management/all-tickets/create-new",
    element: ManageTicket,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/ticket-management/all-tickets/details/:id",
    element: LogTicketDetails,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/ticket-management/all-tickets/approver-details/:id",
    element: ApproverTicketDetails,
    roles: ["super_admin", "Admin"],
  },

  {
    path: "/admin/ticket-management/all-tickets/creator-details/:id",
    element: CreatorTicketDetails,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/ticket-management/approval-hub",
    element: AssignToMe,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/ticket-management/approval-hub/approver-details/:id",
    element: ApproverTicketDetails,
    roles: ["super_admin", "Admin"],
  },

  // Ticket Management-> Ticket Routes (User)
  {
    path: "/user/ticket-management",
    element: AllTickets,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/all-tickets",
    element: AllTickets,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/all-tickets/create-new",
    element: ManageTicket,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/all-tickets/details/:id",
    element: LogTicketDetails,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/all-tickets/approver-details/:id",
    element: ApproverTicketDetails,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/all-tickets/creator-details/:id",
    element: CreatorTicketDetails,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/approval-hub",
    element: AssignToMe,
    roles: ["User"],
  },
  {
    path: "/user/ticket-management/approval-hub/approver-details/:id",
    element: ApproverTicketDetails,
    roles: ["User"],
  },

  // Ticket Management-> Template Routes
  {
    path: "/admin/ticket-management/all-templates",
    element: AllTemplates,
    roles: ["super_admin"],
  },
  {
    path: "/admin/ticket-management/all-templates/create-new",
    element: ManageTemplate,
    roles: ["super_admin"],
  },
  {
    path: "/admin/ticket-management/all-templates/create",
    element: ManageTemplate,
    roles: ["super_admin"],
  },
  {
    path: "/admin/ticket-management/all-templates/update/:id",
    element: ManageTemplate,
    roles: ["super_admin"],
  },
  {
    path: "/admin/ticket-management/all-templates/edit-ticket/:id",
    element: ManageTemplate,
    roles: ["super_admin"],
  },
  {
    path: "/admin/ticket-management/all-templates/template-details/:id",
    element: TemplateDetails,
    roles: ["super_admin"],
  },
  {
    path: "/user/ticket-management/all-templates/template-details/:id",
    element: TemplateDetails,
    roles: ["User"],
  },

  // Product Management Routes
  {
    path: "/admin/product-management/all-products",
    element: AllProducts,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/admin/product-management/all-features",
    element: AllFeatures,
    roles: ["super_admin", "Admin"],
  },

  // Company Profile Routes
  {
    path: "/admin/company-profile",
    element: CompanyProfile,
    roles: ["super_admin", "Admin"],
  },

  // Profile routes
  {
    path: "/admin/profile",
    element: AdminProfile,
    roles: ["super_admin", "Admin"],
  },
  {
    path: "/user/profile",
    element: AdminProfile,
    roles: ["User"],
  },
  {
    path: "/user/users",
    element: User,
    roles: ["User"],
  },

  // Report routes
  {
    path: "/admin/reports",
    element: Reports,
    roles: ["Admin", "super_admin"],
  },
  {
    path: "/user/reports",
    element: Reports,
    roles: ["User"],
  },
];

// public routers
export const publicRouters: Omit<RouteType, "roles">[] = [
  {
    path: "/sign-in",
    element: KeycloakSignIn,
  },
  {
    path: "/sign-up",
    element: SignUp,
  },
  {
    path: "/forgot-password",
    element: ForgotPassword,
  },
  {
    path: "/reset-password",
    element: ResetPassword,
  },
  {
    path: "/404",
    element: NotFound,
  },
  {
    path: "*",
    element: NotFound,
  },
];
